﻿import { FC, InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  errorMessage?: string;
  error?: string;
  id: string;
}

export const Input: FC<InputProps> = ({
  label,
  helperText,
  errorMessage,
  error,
  id,
  required,
  className = '',
  disabled,
  ...props
}) => {
  const activeError = error || errorMessage;
  const hasError = Boolean(activeError);
  const describedBy = activeError ? `${id}-error` : helperText ? `${id}-helper` : undefined;

  return (
    <div style={{ marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
      {label && (
        <label
          htmlFor={id}
          style={{
            fontSize: '0.875rem',
            fontWeight: 600,
            color: 'var(--color-navy-dark)'
          }}
        >
          {label} {required && <span style={{ color: '#e11d48' }} aria-hidden="true">*</span>}
        </label>
      )}
      <input
        id={id}
        required={required}
        disabled={disabled}
        aria-invalid={hasError}
        aria-describedby={describedBy}
        style={{
          width: '100%',
          padding: '0.625rem 0.75rem',
          fontSize: '0.9375rem',
          borderRadius: 'var(--radius-md)',
          border: `1px solid ${hasError ? '#e11d48' : 'var(--color-border-strong)'}`,
          backgroundColor: disabled ? '#f1f5f9' : '#ffffff',
          color: 'var(--color-text-primary)',
          fontFamily: 'inherit'
        }}
        className={className}
        {...props}
      />
      {activeError && (
        <span id={`${id}-error`} role="alert" style={{ fontSize: '0.75rem', color: '#b91c1c' }}>
          {activeError}
        </span>
      )}
      {!activeError && helperText && (
        <span id={`${id}-helper`} style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)' }}>
          {helperText}
        </span>
      )}
    </div>
  );
};

